import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TransactionWrapper} from '../../../../../model/transactionWrapper';
import {Constants} from '../../../../../constants/ebtq-constants';
import {ApiService} from '../../../../../services/api.service';
import {UtilityService} from '../../../../../services/utility-service';

@Component({
  standalone: false,
  selector: 'app-service-transfer-loan-select',
  templateUrl: './service-transfer-loan-select.component.html',
  styleUrls: ['./service-transfer-loan-select.component.scss']
})
export class ServiceTransferLoanSelectComponent implements OnInit, AfterViewInit {


  @Input('loanNumbers')
    loanDetails:any[];

  @Input()
    servicerNumber: string;

  @Input()
    effectiveDate:any;

  @Input()
    oldServicerNumber:string;
  @Input()
    portFolioInd:any;

  @Output()
    loanSubmitClick = new EventEmitter<any[]>();
  loanDetailsDisplay:any[] = [];
  selectedLoans:string[];
  transactionWrapper: TransactionWrapper;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    console.log('loanDetails', this.loanDetails);

    this.loanDetails.forEach(elem=>{
    //this.loanDetailsDisplay.push({label:elem.LOANNUM ,value:elem.LN_ID});
      this.loanDetailsDisplay.push({label:elem.LOANNUM, value:elem.LOANNUM});
    });

  }


  clearBtn()
  {
    this.selectedLoans = [];
  }
  ngAfterViewInit(): void {

    console.log('loanDetails view', this.loanDetails);
  }

  //To Transfer the loans to a new servicer number
  loanSubmit()
  {
    const loanDetailsMap = new Map();
    this.loanDetails.forEach(elem=>{
      loanDetailsMap.set(elem.LOANNUM, elem.LN_ID.toString());
    });

    const userId = sessionStorage.getItem('userID');
    const utilService = new UtilityService();
    const effecDate =  utilService.convertDateToMillisec(this.effectiveDate);
    console.log('efec=ec date:', effecDate);

    const serviceTransaferAction : any = {
      transferee : this.servicerNumber,
      servicerNumber: this.oldServicerNumber,
      transferPortfolioOption : {code: Number(this.portFolioInd), description: ''},
      deleteLoanFlag :  false,
      effectiveDate:{date:effecDate},
      recordCreatorUserID:userId,
      lastUpdatedUserId: userId

    };

    const loanList: string[] = [];

    if (this.portFolioInd === '4')
    {
      this.selectedLoans.forEach(loan=>{
        loanList.push(loan.toString());
      });
    }
    else {
      this.loanDetails.forEach(elem=>{
        loanList.push(elem.LOANNUM.toString());
      });
    }


    const autoConvertMapToObject = (map) => {
      const obj = {};
      for (const item of [...map]) {
        const [
          key,
          value
        ] = item;
        obj[key] = value;
      }
      return obj;
    };

    const obj = autoConvertMapToObject(loanDetailsMap);


    this.transactionWrapper = new TransactionWrapper();
    this.transactionWrapper.queryServiceName = Constants.INSERT_SERVICER_TRANSFER_LIST;
    this.transactionWrapper.parameters[0] = serviceTransaferAction;
    this.transactionWrapper.parameters[1] = loanList;
    this.transactionWrapper.parameters[2] = obj;


    this.apiService.executeQuery(this.transactionWrapper).subscribe((data: any)=>{
      console.log('data', data);
      // if success below call should happen
      // else display error message
      const serverTransferResponse:any[] = [];
      if (data && data.object && data.object.errorMessages) {
        serverTransferResponse[0] = 'errorMessages';
        serverTransferResponse[1] = data.object.errorMessages;
      } else {
        serverTransferResponse[0] = 'success';
        serverTransferResponse[1] = loanList;
       
      }
      this.loanSubmitClick.next(serverTransferResponse);
    },
    error=>{
      console.log(error);
    });



  }

}
